import { Reducer } from 'redux';
import storageService from 'app/core/services/storageService';
import { StorageKeysEnum } from 'app/core/enums/storage';
import { CommonState, CommonActions, COMMON__INIT_FETCH_COMMON_DATA_DONE, COMMON__SAVE_MEMBER_AUTHORIZATION, COMMON__FETCH_MEMBER_PROFILE_DONE, COMMON__RESET_MEMBER_CACHE } from './types';

const initialState: CommonState = {
  member: {
    authorization: JSON.parse(storageService.getItem(StorageKeysEnum.Authorization)) ?? null
  },
  systemParameters: [],
  systemOptions: [],
  systemMessages: [],
  postcodes: [],
  getnationList: [],
  countries: [],
  nativeCountry: null,
  foreignCountries: [],
  relationshipPrecedenceOptions: [],
  relationshipProportionOptions: [],
  relationshipPrecedenceU7Options: [],
  relationshipProportionU7Options: [],
  bankList: [],
  links: {},
  baseUrls: [],
  jobs: []
};

const commonReducer: Reducer<CommonState, CommonActions> = (state = initialState, action): CommonState => {
  switch (action.type) {
    // 初始取得系統共用選項資料
    case COMMON__INIT_FETCH_COMMON_DATA_DONE: {
      return { ...state, ...action.payload.response };
    }
    // 緩存「會員主檔」和「Access Token」
    case COMMON__SAVE_MEMBER_AUTHORIZATION: {
      return { ...state, member: { ...state.member, authorization: action.payload.authorization } };
    }
    // 取得會員資料 完成
    case COMMON__FETCH_MEMBER_PROFILE_DONE: {
      return { ...state, member: { ...state.member, profile: action.payload.response } };
    }
    // 重置會員相關資料緩存
    case COMMON__RESET_MEMBER_CACHE: {
      return { ...state, member: { ...initialState.member, authorization: null } };
    }
    // Default
    default:
      return state;
  }
};

export default commonReducer;
